import type { StorePlanningClockStatus, StorePlanningCoverageKind } from '@gozoki/api-types'
import { CLOCK_COLOR, CLOCK_LABEL, COVERAGE_COLOR, COVERAGE_LABEL } from './planning-constants'
import { AffluenceIcon, ClockGlyph } from './planning-icons'

const CLOCK_STATUSES: StorePlanningClockStatus[] = ['on_time', 'late', 'missing']
const COVERAGE_KINDS: StorePlanningCoverageKind[] = ['presentiel', 'distanciel', 'ouverture']

function Entry({ mark, label }: { mark: React.ReactNode; label: string }) {
  return (
    <span className="flex shrink-0 items-center gap-[6px] font-sans text-[12px] text-[#072C1A]">
      {mark}
      {label}
    </span>
  )
}

export function PlanningLegend() {
  return (
    <div className="flex shrink-0 items-center gap-[22px]">
      {CLOCK_STATUSES.map((status) => (
        <Entry
          key={status}
          label={CLOCK_LABEL[status]}
          mark={
            <span
              className="flex items-center rounded-full bg-[#F4EEDB] p-[2px]"
              style={{ color: CLOCK_COLOR[status] }}
            >
              <ClockGlyph />
            </span>
          }
        />
      ))}
      <Entry mark={<AffluenceIcon />} label="Affluence" />
      {COVERAGE_KINDS.map((kind) => (
        <Entry
          key={kind}
          label={COVERAGE_LABEL[kind]}
          mark={
            <span
              className="h-[16px] w-[6px] rounded-[2px]"
              style={{ backgroundColor: COVERAGE_COLOR[kind] }}
            />
          }
        />
      ))}
    </div>
  )
}
